var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17H3.5C3.224 17 3 16.776 3 16.5V3.5C3 3.224 3.224 3 3.5 3H16.5C16.776 3 17 3.224 17 3.5V16.5C17 16.776 16.776 17 16.5 17Z",
    fill: "#A2845E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3V10L7.859 9.141C7.937 9.063 8.064 9.063 8.142 9.141L8.859 9.858C8.937 9.936 9.064 9.936 9.142 9.858L9.859 9.141C9.937 9.063 10.064 9.063 10.142 9.141L10.859 9.858C10.937 9.936 11.064 9.936 11.142 9.858L11.859 9.141C11.937 9.063 12.064 9.063 12.142 9.141L13 10V3H7Z",
    fill: "#FF9500"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox1);
export default __webpack_public_path__ + "static/media/box1.184fc4fc5677ac27328840cb3324cf0f.svg";
export { ForwardRef as ReactComponent };